<script lang="ts">
    import { mdiTrashCan, mdiPlus, mdiPackageVariantClosed } from "@mdi/js"
    import Icon from "../../../widgets/Icon.svelte"
    import { tooltip } from "../../../../helper"
    import TextField from "../edit/fields/TextField.svelte"
    import NumberField from "../../../widgets/fields/NumberField.svelte"
    import { operationHashBeginning } from "../../../../store"
    import { _ } from "svelte-i18n"

    export let operationEmailed: boolean
    export let operation: OperationOut
    export let grid: boolean
    export let gridBreakPoint: number
    const addNewAdditionalPosition = () => {
        if (!operation.additionalPositions) {
            operation.additionalPositions = []
        }

        // Calculate new number for new additional position
        let newServiceNumber: number = 0
        if (operation?.additionalPositions?.length) {
            operation.additionalPositions.forEach((position) => {
                if (position.number > newServiceNumber) {
                    newServiceNumber = position.number
                }
            })
        }

        operation.additionalPositions.push({
            amount: 1,
            number: newServiceNumber + 1,
            service: "",
            description: "",
            netPrice: 0,
        })

        // Force template update after change position quantity
        operation.additionalPositions = operation.additionalPositions
    }

    const removeAdditionalPosition = (additionalPosition: AdditionalPosition) => {
        for (let i = 0; i < operation?.additionalPositions?.length; i++) {
            if (operation?.additionalPositions?.[i]?.number === additionalPosition.number) {
                operation.additionalPositions.splice(i, 1)
            }
        }

        // Update position numbers
        for (let i = 0; i < operation?.additionalPositions?.length; i++) operation.additionalPositions[i].number = i + 1

        // Force template update after change position quantity
        operation.positions = operation.positions
    }
    let outerWidth: number
    let rows: HTMLDivElement[] = []
</script>

<svelte:window bind:outerWidth />

{#if operation?.additionalPositions?.length}
    <h4 class="additional-positions-header" style="width: 350px;">
        {#if !!operation?.statusSummary?.emailed || !!operation?.statusSummary?.orderConfimationEmailed}
            {operation.additionalPositionsPdfName || $_("components.additionalPosition.additionalPosition")}
        {:else}
            <TextField
                label="{$_('components.additionalPosition.headingInPdf')}"
                value="{operation.additionalPositionsPdfName || $_('components.additionalPosition.additionalPosition')}"
                on:blur="{(e) => {
                    if (operation.additionalPositionsPdfName === e.detail) return
                    operation.additionalPositionsPdfName = e.detail
                }}"
            />
        {/if}
    </h4>
    <div
        class="table"
        class:gridview="{grid == undefined ? outerWidth <= gridBreakPoint : grid}"
        class:tableview="{grid == undefined ? outerWidth > gridBreakPoint : !grid}"
    >
        {#each operation.additionalPositions || [] as position, i}
            {#key $operationHashBeginning}
                <div bind:this="{rows[i]}" class="tablerow trow relative additional-positions">
                    <div class="col col-as-mobile-header center middle w-80" style="flex-grow: 0;">
                        <Icon path="{mdiPackageVariantClosed}" size="24px" />
                        <div class="hidden-on-table">
                            {$_("components.additionalPosition.additionalPosition")}
                            {position.number}
                        </div>
                    </div>
                    <div class="col middle">
                        {#if !!operation?.statusSummary?.emailed || !!operation?.statusSummary?.orderConfimationEmailed}
                            <NumberField value="{position.amount}" />
                        {:else}
                            <TextField
                                type="number"
                                label="{$_('components.additionalServices.amount')}"
                                decimal="{0}"
                                bind:value="{position.amount}"
                                higherThanZero="{true}"
                                cssClass="transparent"
                                disabled="{operationEmailed}"
                            />{/if}
                    </div>
                    <div class="col middle w-auto dominantxxl">
                        {#if !!operation?.statusSummary?.emailed || !!operation?.statusSummary?.orderConfimationEmailed}
                            {position.service}
                        {:else}
                            <TextField
                                label="{$_('components.additionalServices.service')}"
                                bind:value="{position.service}"
                                cssClass="transparent"
                                disabled="{operationEmailed}"
                            />{/if}
                    </div>
                    <div class="col middle w-auto dominantxxl">
                        {#if !!operation?.statusSummary?.emailed || !!operation?.statusSummary?.orderConfimationEmailed}
                            {position.description}
                        {:else}
                            <TextField
                                row="{rows[i]}"
                                label="{$_('components.additionalServices.description')}"
                                multipleLines="{true}"
                                bind:value="{position.description}"
                                cssClass="transparent"
                                disabled="{operationEmailed}"
                            />
                        {/if}
                    </div>
                    <div class="col middle w-150 pw-180">
                        {#if !!operation?.statusSummary?.emailed || !!operation?.statusSummary?.orderConfimationEmailed}
                            <NumberField value="{position.netPrice}" />
                        {:else}
                            <div style="display: flex; gap: 10px; align-items: flex-end;">
                                <strong style="margin-bottom: 5px"
                                    >{$_("components.additionalServices.salesPrice")}
                                </strong>
                                <TextField
                                    type="number"
                                    label="{$_('components.additionalServices.price')}"
                                    disabled="{operationEmailed}"
                                    bind:value="{position.netPrice}"
                                    showEuroSymbol="{true}"
                                    cssClass="transparent"
                                />
                            </div>
                        {/if}
                    </div>

                    <div class="col mw-100 w-100 pw-140 action_buttons" style="justify-content: flex-start;">
                        {#if !operation?.statusSummary?.emailed && !operation?.statusSummary?.orderConfimationEmailed}
                            <button
                                class="btn delete"
                                use:tooltip="{{
                                    content: $_('components.additionalServices.deleteService'),
                                }}"
                                on:click|stopPropagation="{() => removeAdditionalPosition(position)}"
                            >
                                <Icon path="{mdiTrashCan}" size="24px" />
                            </button>
                        {/if}
                    </div>
                </div>
            {/key}
        {/each}
    </div>
{/if}
{#if !operation?.statusSummary?.emailed && !operation?.statusSummary?.orderConfimationEmailed}
    <div class="add-additional-position relative">
        <button
            class="btn btn-secondary btn-rounded"
            on:click|stopPropagation="{addNewAdditionalPosition}"
            use:tooltip="{{
                content: $_('components.additionalPosition.additionalPositionAdd'),
            }}"
        >
            <Icon path="{mdiPlus}" size="24px" />
        </button>
        <div>{$_("components.additionalPosition.addAdditionalPosition")}</div>
    </div>
{/if}
